/** 
 * !!! DO NOT MODIFY !!!
 * 
 * File generated from types definition in project https://forge.cadoles.com/EFS/sheila.
 *
 * See misc/script/generate-type-defs.sh script for more informations.
 **/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analysisRequestMatches = exports.AnalysisRequestCodeLifecycle = exports.ResultCodeDataType = exports.AnalysisRequestState = void 0;
// Voir CCTP-IT09.pdf - II. STATUTS ET CYCLES DE VIE, A. STATUTS ET CYCLES DE VIE
var AnalysisRequestState;
(function (AnalysisRequestState) {
    // Stade 1 - La demande est prise en compte (reçu d’Inlog Labo server)
    AnalysisRequestState["TakenIntoAccount"] = "taken-into-account";
    // Stade 2 - Les examens de la demande sont intégrés dans des listes de travail qui sont exportés vers les automates
    AnalysisRequestState["IntegratedWorklist"] = "integrated-worklist";
    // Stade 3 - Des résultats sont importés dans le middleware pour chaque examen de cette
    // demande, à partir de HLA-FUSION et / ou Match-it. Ils sont soumis aux algorithmes
    // d'aide à l'interprétation paramétrés par labo
    AnalysisRequestState["ReceivedResults"] = "received-results";
    // Stade 4 - Les résultats de l'examens sont validés techniquement (VT), les résultats
    // peuvent être dévalidés par les profils utilisateurs définis
    AnalysisRequestState["TechValidatedResults"] = "tech-validated-results";
    // Stade 5 - Les résultats de l'examens sont validés avec composante experte (VE) par
    // les profils utilisateurs définis. Les résultats au stade VE ne peuvent être dévalidés et
    // modifiés que par un biologiste médical pour revenir à un stade VT.
    AnalysisRequestState["ExpertValidatedResults"] = "expert-validated-results";
    // Stade 6 - Les résultats sont transférés dans inlog laboserveur en format norme HPRIM
    // les résultats peuvent être dévalidés par un biologiste médical pour repasser au stade
    // pour être modifiable, puis passage en VE, puis réexportable après validation.
    AnalysisRequestState["TransferedResults"] = "transfered-results";
    // Stade 0 - Reprise des demandes données antérieures à la première nouvelle demande
    // validée dans l'outil – non exportable – non dévalidable
    //
    // Précision apportée par @srubier:
    // "C'est pour permettre d'interroger un dossier patient quand celui-ci n'a jamais reçu 
    // une demande analytique. Je précise. On prévoit envoyer un hprim pour un patient avec 
    // un code spécifique qui permet juste de déclencher le pipeline hprim import sans que 
    // ce soit un examen. Une sorte de première intégration pour consultation."
    AnalysisRequestState["Historized"] = "historized";
    // Une demande d'analyse est en attente de résultat si elle fait partie d'une liste de travail dans l'état "exportée"
    AnalysisRequestState["PendingResult"] = "pending-result";
    /**
     * Stade 7 - L'examen est mis « à refaire » (ticket #821) depuis une liste de
     * travail exportée : il réintègre le pot commun des examens sélectionnables
     * pour une nouvelle liste de travail. Accessible depuis les stades 2 à 6,
     * sans limite de répétition.
     */
    AnalysisRequestState["RedoRequested"] = "redo-requested";
})(AnalysisRequestState || (exports.AnalysisRequestState = AnalysisRequestState = {}));
// Type de donnée associé au code de résultat
// d'examen
// Voir https://nextcloud.cadoles.com/nextcloud/index.php/f/223720
var ResultCodeDataType;
(function (ResultCodeDataType) {
    // Groupe de résultats
    ResultCodeDataType["RESULT_GROUP"] = "result-group";
    // MFI CP
    ResultCodeDataType["MFI_CP"] = "mfi-cp";
    // MFI CN
    ResultCodeDataType["MFI_CN"] = "mfi-cn";
    // MFI max (hors CP)
    ResultCodeDataType["MFI_MAX"] = "mfi-max";
    // Synthèse des spécificité positives
    ResultCodeDataType["SYNTH_POS"] = "synth-pos";
    // Commentaire libre
    ResultCodeDataType["COM"] = "com";
    // Catalogue
    ResultCodeDataType["CAT"] = "cat";
    // Seuil classe
    ResultCodeDataType["CLASS_THRESHOLD"] = "class-threshold";
    // MFI DSA
    ResultCodeDataType["MFI_DSA"] = "mfi-dsa";
    // DSA
    ResultCodeDataType["DSA"] = "dsa";
    // Date Serum N-1
    ResultCodeDataType["DATE_SERUM_N1"] = "date-serum-n1";
    // Résultat classe
    ResultCodeDataType["CLASS_RESULT"] = "class-result";
    // Ag classe 1/2
    ResultCodeDataType["AG"] = "ag";
    // Non implémenté
    ResultCodeDataType["NOT_IMPLEMENTED"] = "not-implemented";
})(ResultCodeDataType || (exports.ResultCodeDataType = ResultCodeDataType = {}));
var AnalysisRequestCodeLifecycle;
(function (AnalysisRequestCodeLifecycle) {
    AnalysisRequestCodeLifecycle["Synthesis"] = "synthesis";
    AnalysisRequestCodeLifecycle["Punctual"] = "punctual";
})(AnalysisRequestCodeLifecycle || (exports.AnalysisRequestCodeLifecycle = AnalysisRequestCodeLifecycle = {}));
function analysisRequestMatches(r1, r2) {
    return r1.executorSampleId === r2.executorSampleId &&
        r1.requestDate === r2.requestDate &&
        r1.requestorSampleId === r2.requestorSampleId &&
        r1.samplingEndDate === r2.samplingEndDate &&
        r1.samplingStartDate === r2.samplingStartDate &&
        r1.type === r2.type;
}
exports.analysisRequestMatches = analysisRequestMatches;
